import styled, { css } from 'styled-components'

import { Close } from '../Icons'

export const ClearIcon = styled(Close)`
  border-radius: 50%;
  background-color: ${({ bgColor }) => bgColor || 'var(--ds-blue-8)'};

  svg path {
    fill: var(--ds-gray-2);
  }

  &:hover,
  &:focus {
    background-color: ${({ bgHoverColor }) => bgHoverColor || 'var(--ds-blue-7)'};

    svg path {
      fill: var(--ds-button-hover);
    }
  }
`

export const StyledFieldWrapper = styled.div`
  transition: all 0.3s;

  .ant-input-clear-icon {
    display: flex;
  }

  .ant-input-prefix {
    margin-inline-end: 10px;
  }

  .ant-input {
    font-size: 13px !important;
    line-height: normal;
  }

  ${({ disabled, readOnly, maxWidth }) => css`
    ${
      disabled &&
      css`
        svg path {
          fill: var(--ds-gray-5);
        }
      `
    }

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-input-group-addon {
      color: ${disabled ? 'var(--ds-gray-5)' : 'var(--ds-gray-1)'};
      border-width: 1px;
      border-style: solid;
      border-color: ${disabled || readOnly ? 'var(--ds-blue-6)' : 'var(--input-border-color)'};
      border-radius: 8px;
      background: var(--color-surface);
      box-shadow: none;
    }

    .ant-input::placeholder {
      color: ${disabled ? 'var(--ds-gray-5)' : 'var(--ds-gray-3)'} !important;
    }

    .ant-input-affix-wrapper {
      max-width: ${maxWidth || 'auto'};
    }

    &.__hover .ant-input,
    &.__hover .ant-input-affix-wrapper,
    &.__hover .ant-input-group-addon,
    &:hover .ant-input,
    &:hover .ant-input-affix-wrapper,
    &:hover .ant-input-group-addon,
    &:focus-within .ant-input,
    &:focus-within .ant-input-affix-wrapper,
    &:focus-within .ant-input-group-addon {
      border-color: ${!(disabled || readOnly) ? 'var(--primary)' : 'var(--input-border-color)'};
    }

    .error,
    .error .ant-input-group-addon,
    .error .ant-input-affix-wrapper,
    .ant-input-group-wrapper.error .ant-input-group-addon,
    .ant-input-group-wrapper.error .ant-input-affix-wrapper {
      border-color: var(--negative-color) !important;
    }

    .ant-input::placeholder {
      color: var(--ds-gray-3);
      font-size: 13px !important;
    }
  `}
`

export const Feedback = styled.span`
  color: ${({ disabled }) => (disabled ? 'var(--ds-gray-5)' : 'var(--ds-gray-3)')};
  font-size: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: left;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 14px;
    height: 14px;
  }

  svg path {
    fill: ${({ disabled }) => (disabled ? 'var(--ds-gray-5)' : 'var(--ds-gray-2)')};
  }

  ${({ error }) =>
    error &&
    css`
      color: var(--negative-color) !important;

      svg path {
        fill: var(--negative-color);
      }
    `}
`
